import { render, staticRenderFns } from "./AppPaginationFooter.vue?vue&type=template&id=5919254a&scoped=true&"
import script from "./AppPaginationFooter.vue?vue&type=script&lang=js&"
export * from "./AppPaginationFooter.vue?vue&type=script&lang=js&"
import style0 from "./AppPaginationFooter.vue?vue&type=style&index=0&id=5919254a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5919254a",
  null
  
)

export default component.exports